export const zIndexAvatarImageAfter = 2;
export const zIndexHeroImage = 3;
export const zIndexNavbar = 4;
export const zIndexFeedbackButton = 5;
export const zIndexSmallScreenFooter = 6;
export const zIndexGlobalAlert = 7;
export const zIndexDropdown = 8;
export const zIndexModal = 9;
